module.exports = __webpack_public_path__ + "img/cake.2edb8393.png";